import React from "react";
import { Link } from "gatsby";

export default () => {
  return (
    <section>
      <div className="container mx-auto">
        <div className="flex flex-wrap mt-10 overflow-hidden">
          <div className="w-full overflow-hidden xl:w-2/12"></div>

          <div className="w-full overflow-hidden text-center xl:w-8/12">
            <div className="py-4 mx-auto align-middle bg-blue-100 lg:pt-4 lg:h-16">
              <p className="inline-block mr-2 text-gray-500">Es fácil comenzar y nos aseguramos de que toda tu información se mantenga confidencial</p>
              <Link
                to="/app/login"
                className="inline-block px-3 py-2 text-gray-500 bg-yellow-500 border border-yellow-500 rounded focus:text-gray-500 focus:bg-yellow-500 focus:border-yellow-500 hover:bg-gray-500 hover:border-gray-500 hover:text-yellow-500"
              >
                Empieza a ahorrar
              </Link>
            </div>
          </div>

          <div className="w-full overflow-hidden xl:w-2/12"></div>
        </div>
      </div>
    </section>
  );
};
